<template>
  <sui-page>
    <sui-page-header title="Form UI"></sui-page-header>
    <sui-page-contents>
      <h1 class="-page-header-title-main__title">타이틀이 여기에 들어가면 어떻게 보이나</h1>
      <div class="mrB15"/>
      <div class="comm_view_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label label="텍스트필드텍스트필드텍스트필드텍스트필드" required ></sui-input-label>
          </div>
          <div class="col-xs-3">
            <sui-text-field placeholder="Input text" default value ></sui-text-field>
          </div>
          <div class="col-xs-1">
            <sui-input-label label="텍스트필드/readonly" optional></sui-input-label>
          </div>
          <div class="col-xs-3">
            <sui-text-field placeholder="Input text" default value="This textfield is readonly." readonly></sui-text-field>
          </div>
          <div class="col-xs-1">
            <sui-input-label label="텍스트필드/disabled" ></sui-input-label>
          </div>
          <div class="col-xs-3">
            <sui-text-field placeholder="Input text" default value="This textfield is readonly." disabled></sui-text-field>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label label="셀렉트박스" optional></sui-input-label>
          </div>
          <div class="col-xs-3">
            <sui-select-box :value="{ label: '', key: '' }" :option-list="[{ label: 'select001 ', key: '' }, { label: 'select0002', key: '' }, { label: 'select00003', key: '' }, { label: 'select000000000000004', key: '' }]" placeholder="selectbox"
              >
            </sui-select-box>
          </div>
          <div class="col-xs-1">
            <sui-input-label label="셀렉트박스/readonly" :required="true" :vertical="false"></sui-input-label>
          </div>
          <div class="col-xs-3">
            <sui-select-box :value="{ label: '', key: '' }" :option-list="[{ label: 'select001 ', key: '' }, { label: 'select0002', key: '' }, { label: 'select00003', key: '' }, { label: 'select000000000000004', key: '' }]" placeholder="selectbox"
              readonly>
            </sui-select-box>
          </div>
          <div class="col-xs-1">
            <sui-input-label label="셀렉트박스/disabled" readonly></sui-input-label>
          </div>
          <div class="col-xs-3">
            <sui-select-box :value="{ label: '', key: '' }" :option-list="[{ label: 'select001 ', key: '' }, { label: 'select0002', key: '' }, { label: 'select00003', key: '' }, { label: 'select000000000000004', key: '' }]" placeholder="selectbox"
              disabled>
            </sui-select-box>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label label="텍스트에리어" optional></sui-input-label>
          </div>
          <div class="col-xs-3">
            <textarea placeholder="텍스트입력"></textarea>
          </div>
          <div class="col-xs-1">
            <sui-input-label label="텍스트에리어/readonly" readonly></sui-input-label>
          </div>
          <div class="col-xs-3">
            <textarea placeholder="텍스트입력" readonly>This textarea field is readonly.</textarea>
          </div>
           <div class="col-xs-1">
            <sui-input-label label="텍스트에리어/disabled" readonly></sui-input-label>
          </div>
          <div class="col-xs-3">
            <textarea placeholder="텍스트입력" disabled>This textarea field is readonly.</textarea>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label label="서치인풋"></sui-input-label>
          </div>
          <div class="col-xs-3">
            <sui-text-field dataset="dataset0.pageName" v-model="pageName" :clearable="true" fixed-icon />
          </div>
          <div class="col-xs-1">
            <sui-input-label label="서치인풋/readonly" readonly></sui-input-label>
          </div>
          <div class="col-xs-3">
            <sui-text-field dataset="dataset0.pageName" v-model="pageName" :clearable="true" fixed-icon readonly />
          </div>
          <div class="col-xs-1">
            <sui-input-label label="서치인풋/disabled" :required="true" :vertical="false" readonly></sui-input-label>
          </div>
          <div class="col-xs-3">
            <sui-text-field dataset="dataset0.pageName" v-model="pageName" :clearable="true" fixed-icon disabled />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label label="데이트피커" :required="true" :vertical="false"></sui-input-label>
          </div>
          <div class="col-xs-3">
            <sui-date-picker :disabled="false" sticky></sui-date-picker>
          </div>
          <div class="col-xs-1">
            <sui-input-label label="데이트피커/readonly" :required="true" :vertical="false"></sui-input-label>
          </div>
          <div class="col-xs-3">
            <sui-date-picker :disabled="false" :readonly="true" sticky></sui-date-picker>
          </div>
          <div class="col-xs-1">
            <sui-input-label label="데이트피커/disabled" :required="true" :vertical="false"></sui-input-label>
          </div>
          <div class="col-xs-3">
            <sui-date-picker :disabled="true" sticky></sui-date-picker>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label label="타임피커" :required="true" :vertical="false"></sui-input-label>
          </div>
          <div class="col-xs-3">
            <sui-time-picker :value="{ HH: '14', mm: '10'}" format="HH:mm"></sui-time-picker>
          </div>
          <div class="col-xs-1">
            <sui-input-label label="타임피커/readonly" :required="true" :vertical="false" readonly></sui-input-label>
          </div>
          <div class="col-xs-3">
            <sui-time-picker :value="{ HH: '14', mm: '10'}" format="HH:mm" readonly></sui-time-picker>
          </div>
          <div class="col-xs-1">
            <sui-input-label label="타임피커/disabled" :required="true" :vertical="false" readonly></sui-input-label>
          </div>
          <div class="col-xs-3">
            <sui-time-picker :value="{ HH: '14', mm: '10'}" format="HH:mm" disabled></sui-time-picker>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label label="패스워드" :required="true" :vertical="false"></sui-input-label>
          </div>
          <div class="col-xs-3">
            <sui-text-field value :password="true"></sui-text-field>
          </div>
          <div class="col-xs-1">
            <sui-input-label label="패스워드/readonly" :required="true" :vertical="false" readonly></sui-input-label>
          </div>
          <div class="col-xs-3">
            <sui-text-field value :password="true" readonly></sui-text-field>
          </div>
          <div class="col-xs-1">
            <sui-input-label label="패스워드/disabled" :required="true" :vertical="false" readonly></sui-input-label>
          </div>
          <div class="col-xs-3">
            <sui-text-field value :password="true" disabled></sui-text-field>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label label="다국어" :required="true" :vertical="false"></sui-input-label>
          </div>
          <div class="col-xs-3">
            <cmp-mlng-editor
              :pageId="this.$options.name"
              :vertical="false"
              :editable="true"
              ref="mlngEditor"
             />
          </div>
          <div class="col-xs-1">
            <sui-input-label label="다국어/readonly" :required="true" :vertical="false" readonly></sui-input-label>
          </div>
          <div class="col-xs-3">
            <cmp-mlng-editor
              :pageId="this.$options.name"
              :vertical="false"
              :editable="true"
              readonly
              ref="mlngEditor1"
             />
          </div>
          <div class="col-xs-1">
            <sui-input-label label="다국어/disabled" :required="true" :vertical="false" disabled></sui-input-label>
          </div>
          <div class="col-xs-3">
            <cmp-mlng-editor
              :pageId="this.$options.name"
              :vertical="false"
              :editable="true"
              disabled
              ref="mlngEditor2"
             />
          </div>
        </div>
      </div>
      <div class="mrB50"/>
      <div class="comm_scr_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label label="셀렉트+텍스트필드텍스트필드텍스트필드텍스트필드" :required="true" :vertical="false"></sui-input-label>
          </div>
          <div class="col-xs-3">
            <sui-select-box :value="{ label: '', key: '' }" :option-list="[{ label: 'select001 ', key: '' }, { label: 'select0002', key: '' }, { label: 'select00003', key: '' }, { label: 'select000000000000004', key: '' }]" placeholder="selectbox"
              disabled="true">
            </sui-select-box>
            <div class="comp_spacing"></div>
            <sui-text-field placeholder="Input text" default value :disabled="false" :readonly="false"></sui-text-field>
          </div>
          <div class="col-xs-1">
            <sui-input-label label="텍스트필드텍스트필드텍스트필드텍스트필드텍스트필드텍스트필드텍스트필드텍스트필드텍스트필드텍스트필드텍스트필드" :required="false" :vertical="false"></sui-input-label>
          </div>
          <div class="col-xs-3">
            <sui-text-field placeholder="Input text" default value :disabled="false" :readonly="false"></sui-text-field>
          </div>
          <div class="col-xs-1">
            <sui-input-label label="서치인풋" :required="false" :vertical="false"></sui-input-label>
          </div>
          <div class="col-xs-3">
            <sui-text-field dataset="dataset0.pageName" v-model="pageName" :clearable="true" fixed-icon />
            <div class="info_tooltip" v-tooltip-white="myToolTip"></div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label label="Datepicker" :required="true" :vertical="false"></sui-input-label>
          </div>
          <div class="col-xs-3">
            <sui-date-picker :disabled="false" sticky></sui-date-picker>
          </div>
          <div class="col-xs-1">
            <sui-input-label label="월달력" :required="true" :vertical="false"></sui-input-label>
          </div>
          <div class="col-xs-3">
            <sui-select-box :value="{ label: '', key: '' }" :option-list="[{ label: 'select001 ', key: '' }, { label: 'select0002', key: '' }, { label: 'select00003', key: '' }, { label: 'select000000000000004', key: '' }]" placeholder="selectbox">
            </sui-select-box>
            <div class="comp_spacing"></div>
            <sui-select-box :value="{ label: '', key: '' }" :option-list="[{ label: 'select001 ', key: '' }, { label: 'select0002', key: '' }, { label: 'select00003', key: '' }, { label: 'select000000000000004', key: '' }]" placeholder="selectbox">
            </sui-select-box>
          </div>
          <div class="col-xs-1">
            <sui-input-label label="셀렉트박스" :required="true" :vertical="false"></sui-input-label>
          </div>
          <div class="col-xs-3">
            <sui-select-box :value="{ label: '', key: '' }" :option-list="[{ label: 'select001 ', key: '' }, { label: 'select0002', key: '' }, { label: 'select00003', key: '' }, { label: 'select000000000000004', key: '' }]" placeholder="selectbox">
            </sui-select-box>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label label="셀렉트박스3개" :required="false" :vertical="false"></sui-input-label>
          </div>
          <div class="col-xs-7">
            <sui-select-box :value="{ label: '', key: '' }" :option-list="[{ label: 'select001 ', key: '' }, { label: 'select0002', key: '' }, { label: 'select00003', key: '' }, { label: 'select000000000000004', key: '' }]" placeholder="selectbox">
            </sui-select-box>
            <div class="comp_spacing"></div>
            <sui-select-box :value="{ label: '', key: '' }" :option-list="[{ label: 'select001 ', key: '' }, { label: 'select0002', key: '' }, { label: 'select00003', key: '' }, { label: 'select000000000000004', key: '' }]" placeholder="selectbox">
            </sui-select-box>
            <div class="comp_spacing"></div>
            <sui-select-box :value="{ label: '', key: '' }" :option-list="[{ label: 'select001 ', key: '' }, { label: 'select0002', key: '' }, { label: 'select00003', key: '' }, { label: 'select000000000000004', key: '' }]" placeholder="selectbox">
            </sui-select-box>
          </div>
          <div class="col-xs-1">
            <sui-input-label label="radio"></sui-input-label>
          </div>
          <div class="col-xs-3">
            <sui-radio v-model="radioStrValue" value="radio1" :disabled="true">Radio 1</sui-radio>
            <sui-radio v-model="radioStrValue" value="radio2" :disabled="true">Radio 2</sui-radio>
            <sui-radio v-model="radioStrValue" value="radio3">Radio 3</sui-radio>
          </div>
        </div>
        <div class="comm_detailscr_wrap">
          <sui-button type="button" class="comm_btn_detailscr_open">상세검색 열기</sui-button>
          <div class="comp_spacing"/>
          <sui-button type="button" class="comm_btn_detailscr_close">상세검색 닫기</sui-button>
          <div class="btn_wrap">
            <sui-button type="button" class="comm_btn_Reset ">초기화</sui-button>
            <sui-button type="button" class="comm_btn_Scr">검색</sui-button>
          </div>
        </div>
      </div>
      <div class="mrB30"></div>
      <div class="comm_scr_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label label="default" required></sui-input-label>
          </div>
          <div class="col-xs-3">
            <sui-text-field max-length="100" default value placeholder="input any text"></sui-text-field>
            <div class="comp_spacing"/>
            <sui-button type="button" class="comm_btn_duplicate" title="check duplicates">
            </sui-button>
          </div>
          <div class="col-xs-1">
            <sui-input-label label="currency"></sui-input-label>
          </div>
          <div class="col-xs-3">
            <sui-text-field default mask="currency"></sui-text-field>
            <div class="comp_spacing" />
            <sui-button type="button" class="btn_innerTbl_border">추가</sui-button>
          </div>
          <div class="col-xs-1">
            <sui-input-label label="다국어"></sui-input-label>
          </div>
          <div class="col-xs-3">
            <sui-text-field placeholder="한국어 입력" default value :disabled="false" :clearable="true" :readonly="false"></sui-text-field>
            <div class="comp_spacing" />
            <sui-text-field placeholder="영어 입력" default value :disabled="false" :clearable="true" :readonly="false"></sui-text-field>
            <div class="comp_spacing" />
            <sui-button type="button" class="comm_btn_lang">다국어버튼</sui-button>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label label="password"  :vertical="false"></sui-input-label>
          </div>
          <div class="col-xs-3">
            <sui-text-field dataset="dataset0.pageName" v-model="pageName" :clearable="true" fixed-icon />
          </div>
          <div class="col-xs-1">
            <sui-input-label label="mobile phone"  :vertical="false"></sui-input-label>
          </div>
          <div class="col-xs-3">
            <sui-text-field dataset="dataset0.pageName" v-model="pageName" clearable />
          </div>
          <div class="col-xs-1">
            <sui-input-label label="password"  :vertical="false"></sui-input-label>
          </div>
          <div class="col-xs-3">
            <sui-text-field value :password="true"></sui-text-field>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label label="password" :required="true" :vertical="false"></sui-input-label>
          </div>
          <div class="col-xs-3">
            <sui-text-field value :password="true"></sui-text-field>
          </div>
          <div class="col-xs-1">
            <sui-input-label label="mobile phone" :required="true" :vertical="false"></sui-input-label>
          </div>
          <div class="col-xs-3">
            <sui-text-field placeholder="### - #### - ####" max-length="100" default value mask="full-phone"></sui-text-field>
          </div>
        </div>
        <div class="btn_wrap">
          <div class="comm_infowrap"><p>신청권한 신청상태 및 보유권한에 관한 조회만 가능합니다.</p></div>
          <sui-button type="button" class="comm_btn_Reset ">초기화</sui-button>
          <sui-button type="button" class="comm_btn_Scr">검색</sui-button>
        </div>
      </div>
      <div class="mrB30"></div>
      <div class="comm_scr_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label label="default" :required="true" :vertical="false"></sui-input-label>
          </div>
          <div class="col-xs-3">
            <sui-text-field max-length="100" default value placeholder="input any text"></sui-text-field>
          </div>
          <div class="col-xs-1">
            <sui-input-label label="currency" :required="false" :vertical="false"></sui-input-label>
          </div>
          <div class="col-xs-3">
            <sui-text-field default mask="currency"></sui-text-field>
          </div>
          <div class="btn_wrap">
            <sui-button type="button" class="comm_btn_Reset ">초기화</sui-button>
            <sui-button type="button" class="comm_btn_Scr">검색</sui-button>
          </div>
        </div>
      </div>
      <div class="mrB30"></div>
      <div class="comm_scr_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label label="default" :required="true" :vertical="false"></sui-input-label>
          </div>
          <div class="col-xs-5">
            <sui-text-field max-length="100" default value placeholder="input any text"></sui-text-field>
          </div>
          <div class="col-xs-1">
            <sui-input-label label="currency" :required="false" :vertical="false"></sui-input-label>
          </div>
          <div class="col-xs-5">
            <sui-text-field default mask="currency"></sui-text-field>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label label="password" :required="true" :vertical="false"></sui-input-label>
          </div>
          <div class="col-xs-5">
            <sui-text-field value :password="true"></sui-text-field>
          </div>
          <div class="col-xs-1">
            <sui-input-label label="mobile phone" :required="true" :vertical="false"></sui-input-label>
          </div>
          <div class="col-xs-5">
            <sui-text-field placeholder="### - #### - ####" max-length="100" default value mask="full-phone"></sui-text-field>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label label="disabled" :required="false" :vertical="false"></sui-input-label>
          </div>
          <div class="col-xs-5">
            <sui-text-field placeholder="text not editable" :disabled="true"></sui-text-field>
          </div>
          <div class="col-xs-1">
            <sui-input-label label="readonly" :required="false" :vertical="false"></sui-input-label>
          </div>
          <div class="col-xs-5">
            <sui-text-field placeholder="text not editable" :readonly="true"></sui-text-field>
          </div>
        </div>
        <div class="btn_wrap">
          <sui-button type="button" class="comm_btn_Reset ">초기화</sui-button>
          <sui-button type="button" class="comm_btn_Scr">검색</sui-button>
        </div>
      </div>
      <div class="mrB30"></div>
      <div class="comm_view_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label label="selectbox"></sui-input-label>
          </div>
          <div class="col-xs-3">
            <sui-select-box :value="{ label: '', key: '' }" :option-list="[{ label: 'select001 ', key: '' }, { label: 'select0002', key: '' }, { label: 'select00003', key: '' }, { label: 'select000000000000004', key: '' }]" placeholder="selectbox">
            </sui-select-box>
            <div class="comp_spacing"></div>
            <sui-text-field placeholder="Input text" default value :disabled="false" :clearable="true" :readonly="false"></sui-text-field>
          </div>
          <div class="col-xs-1">
            <sui-input-label label="text-field" :required="true" :vertical="false"></sui-input-label>
            <div class="info_tooltip" v-tooltip-white="myToolTip"></div>
          </div>
          <div class="col-xs-3">
            <sui-text-field placeholder="Input text" default value :disabled="false" :clearable="true" :readonly="false"></sui-text-field>
          </div>
          <div class="col-xs-1">
            <sui-input-label label="checkbox"></sui-input-label>
          </div>
          <div class="col-xs-3">
            <sui-checkbox v-model="singleCheckbox">{{singleCheckbox.toString()}}</sui-checkbox>
            <sui-checkbox v-model="multiCheckbox" value="Chk1">Chk1</sui-checkbox>
            <sui-checkbox v-model="multiCheckbox" value="Chk2">Chk2</sui-checkbox>
            <sui-checkbox v-model="multiCheckbox" value="Chk3">Chk3</sui-checkbox>
            <div class="info_tooltip" v-tooltip-white="myToolTip"></div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label label="radio"></sui-input-label>
          </div>
          <div class="col-xs-3">
            <sui-radio v-model="radioStrValue" value="radio1">Radio 1</sui-radio>
            <sui-radio v-model="radioStrValue" value="radio2">Radio 2</sui-radio>
            <sui-radio v-model="radioStrValue" value="radio3">Radio 3</sui-radio>
          </div>
          <div class="col-xs-1">
            <sui-input-label label="date"></sui-input-label>
          </div>
          <div class="col-xs-3">
            <sui-date-picker :disabled="false" sticky></sui-date-picker>
            <div class="comp_spacing"></div>
            <sui-time-picker :value="{ HH: '14', mm: '10'}" format="HH:mm"></sui-time-picker>
          </div>
          <div class="col-xs-1">
            <sui-input-label label="spin"></sui-input-label>
          </div>
          <div class="col-xs-3">
            <sui-spin :min="0" :step="1" max="10"></sui-spin>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label label="textarea"></sui-input-label>
          </div>
          <div class="col-xs-7">
            <textarea placeholder="텍스트입력"></textarea></div>
          <div class="col-xs-1">
            <sui-input-label label="서치인풋"></sui-input-label>
          </div>
          <div class="col-xs-3">
              <sui-text-field dataset="dataset0.pageName" v-model="pageName" :clearable="true" fixed-icon />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label label="text"></sui-input-label>
          </div>
          <div class="col-xs-3">
            <div class="comm_label">01234567가나다라마바사</div>
          </div>
          <div class="col-xs-1">
            <sui-input-label label="버튼그룹+서치폼"></sui-input-label>
          </div>
          <div class="col-xs-7">
            <div style="width:100%">
              <div class="comm_gridTop_wrap">
                <div class="btn_wrapL">
                  <sui-button type="button" class="comm_btn_gridTop">추가</sui-button>
                  <sui-button type="button" class="comm_btn_gridTop">삭제</sui-button>
                  <sui-button type="button" class="comm_btn_gridTop_Brd">저장</sui-button>
                </div>
                <div class="btn_wrapR">
                  <sui-button type="button" class="comm_btn_gridTop comm_ico_excel">엑셀 다운로드</sui-button>
                  <sui-button type="button" class="comm_btn_gridTop">관련업무</sui-button>
                  <sui-button type="button" class="comm_btn_gridTop_Brd">저장</sui-button>
                </div>
              </div>
              <div class="mrB10"></div>
              <div class="comm_scr_wrap">
                <div class="row">
                  <div class="col-xs-1">
                    <sui-input-label label="기본형" :required="false" :vertical="false"></sui-input-label>
                  </div>
                  <div class="col-xs-5">
                    <sui-date-picker :disabled="false" sticky></sui-date-picker>
                  </div>
                  <div class="col-xs-1">
                    <sui-input-label label="disabled" :required="false" :vertical="false"></sui-input-label>
                  </div>
                  <div class="col-xs-5">
                    <sui-date-picker disabled></sui-date-picker>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xs-1">
                    <sui-input-label sticky label="월달력" :required="false" :vertical="false"></sui-input-label>
                  </div>
                  <div class="col-xs-5">
                    <sui-date-picker format="yyyy-MM" initial-view="month" minimum-view="month" sticky></sui-date-picker>
                  </div>
                  <div class="col-xs-1">
                    <sui-input-label label="기간선택" :required="false" :vertical="false"></sui-input-label>
                  </div>
                  <div class="col-xs-5">
                    <sui-range-date-picker
                      v-model="selectedRangeDate.stringType"
                      @confirm="onConfirm"
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="col-xs-1">
                    <sui-input-label label="일시" :required="false" :vertical="false"></sui-input-label>
                  </div>
                  <div class="col-xs-5">
                    <div class="comm_label"> 2019-01-20 09:35:15</div>
                  </div>
                  <div class="col-xs-1">
                    <sui-input-label label="readonly" :required="false" :vertical="false"></sui-input-label>
                  </div>
                  <div class="col-xs-5">
                    <sui-date-picker :readonly="true"></sui-date-picker>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label label="버튼+그리드"></sui-input-label>
          </div>
          <div class="col-xs-7">
            <div class="comm_inner_div">
              <div class="comm_gridTop_wrap">
                <div class="btn_wrapL">
                  <sui-button type="button" class="comm_btn_gridTop">추가</sui-button>
                  <sui-button type="button" class="comm_btn_gridTop">삭제</sui-button>
                  <sui-button type="button" class="comm_btn_gridTop_Brd">저장</sui-button>
                </div>
                <div class="btn_wrapR">
                  <sui-button type="button" class="comm_btn_gridTop comm_ico_excel">엑셀 다운로드</sui-button>
                  <sui-button type="button" class="comm_btn_gridTop">관련업무</sui-button>
                  <sui-button type="button" class="comm_btn_gridTop_Brd">저장</sui-button>
                </div>
              </div>
              <div class="mrB10"></div>
              <sui-jqx-grid :dataSource="defaultGridData.dataSource" :columns="defaultGridData.columns" :autoheight="true" :autowidth="true" :columnsresize="true" width="100%"></sui-jqx-grid>
            </div>
          </div>
          <div class="col-xs-1">
            <sui-input-label label="서치인풋"></sui-input-label>
          </div>
          <div class="col-xs-3">
            <sui-text-field dataset="dataset0.pageName" v-model="pageName" :clearable="true" fixed-icon />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label label="버튼+그리드"></sui-input-label>
          </div>
          <div class="col-xs-11">

            <div>
              <div class="comm_gridTop_wrap">
                <div class="totalList" style="padding:3px 12px 0 0">총 10개</div>
                <div class="btn_wrapL">
                  <sui-button type="button" class="comm_btn_gridTop">파일찾기</sui-button>
                  <sui-button type="button" class="comm_btn_gridTop">전체삭제</sui-button>
                </div>
              </div>
              <div class="thumbnail_wrap">
                <div><sui-button type="button" class="btn_Pre">앞으로가기</sui-button></div>
                <div class="box">
                  <sui-button type="button" class="btn">대표</sui-button>
                  <div class="imgBox">
                    <sui-button type="button" class="btn_list_del">삭제</sui-button>
                  </div>
                  <div class="file"><a href="#none">파일명01.jpg</a>(3.56KB)</div>
                </div>
                <div class="box">
                  <sui-button type="button" class="btn">대표</sui-button>
                  <div class="imgBox">
                    <sui-button type="button" class="btn_list_del">삭제</sui-button>
                  </div>
                  <div class="file"><a href="#none">파일명01.jpg</a>(3.56KB)</div>
                </div>
                <div class="box">
                  <sui-button type="button" class="btn">대표</sui-button>
                  <div class="imgBox">
                    <sui-button type="button" class="btn_list_del">삭제</sui-button>
                  </div>
                  <div class="file"><a href="#none">파일명01.jpg</a>(3.56KB)</div>
                </div>
                <div class="box">
                  <sui-button type="button" class="btn">대표</sui-button>
                  <div class="imgBox">
                    <sui-button type="button" class="btn_list_del">삭제</sui-button>
                  </div>
                  <div class="file"><a href="#none">파일명01.jpg</a>(3.56KB)</div>
                </div>
                <div class="box">
                  <sui-button type="button" class="btn">대표</sui-button>
                  <div class="imgBox">
                    <sui-button type="button" class="btn_list_del">삭제</sui-button>
                  </div>
                  <div class="file"><a href="#none">파일명01.jpg</a>(3.56KB)</div>
                </div>
                <div><sui-button type="button" class="btn_Next">뒤로가기</sui-button></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="mrB30"></div>
      <div class="comm_view_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label label="토글버튼" :required="true" :vertical="false"></sui-input-label>
          </div>
          <div class="col-xs-5">
            <sui-toggle :value="true"></sui-toggle>
            <div class="mrR30" />
            <sui-toggle :value="true" disabled></sui-toggle>
            <div class="info_tooltip" v-tooltip-white="myToolTip"></div>
          </div>
          <div class="col-xs-1">
            <sui-input-label label="currency" :required="false" :vertical="false"></sui-input-label>
          </div>
          <div class="col-xs-5">
            <sui-text-field default mask="currency"></sui-text-field>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label label="password" :required="true" :vertical="false"></sui-input-label>
          </div>
          <div class="col-xs-5">
            <sui-text-field value :password="true"></sui-text-field>
          </div>
          <div class="col-xs-1">
            <sui-input-label label="mobile phone" :required="true" :vertical="false"></sui-input-label>
          </div>
          <div class="col-xs-5">
            <sui-text-field placeholder="### - #### - ####" max-length="100" default value mask="full-phone"></sui-text-field>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label label="disabled" :required="false" :vertical="false"></sui-input-label>
          </div>
          <div class="col-xs-5">
            <sui-text-field placeholder="text not editable" :disabled="true"></sui-text-field>
          </div>
          <div class="col-xs-1">
            <sui-input-label label="readonly" :required="false" :vertical="false"></sui-input-label>
          </div>
          <div class="col-xs-5">
            <sui-text-field placeholder="text not editable" :readonly="true"></sui-text-field>
          </div>
        </div>
      </div>
      <div class="mrB30"></div>
      <div class="comm_view_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label label="default" :required="true" :vertical="false"></sui-input-label>
          </div>
          <div class="col-xs-5">
            <sui-text-field max-length="100" default value placeholder="input any text"></sui-text-field>
          </div>
          <div class="col-xs-1">
            <sui-input-label label="currency" :required="false" :vertical="false"></sui-input-label>
          </div>
          <div class="col-xs-5">
            <sui-text-field default mask="currency"></sui-text-field>
            <div class="info_tooltip" v-tooltip-white="myToolTip"></div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label label="password" :required="true" :vertical="false"></sui-input-label>
          </div>
          <div class="col-xs-5">
            <sui-text-field value :password="true"></sui-text-field>
          </div>
          <div class="col-xs-1">
            <sui-input-label label="mobile phone" :required="true" :vertical="false"></sui-input-label>
          </div>
          <div class="col-xs-5">
            <sui-text-field placeholder="### - #### - ####" max-length="100" default value mask="full-phone"></sui-text-field>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label label="disabled" :required="false" :vertical="false"></sui-input-label>
          </div>
          <div class="col-xs-5">
            <sui-text-field placeholder="text not editable" :disabled="true"></sui-text-field>
          </div>
          <div class="col-xs-1">
            <sui-input-label label="readonly" :required="false" :vertical="false"></sui-input-label>
          </div>
          <div class="col-xs-5">
            <sui-text-field placeholder="text not editable" :readonly="true"></sui-text-field>
          </div>
        </div>
      </div>
      <div class="mrB15"></div>
      <div class="comm_title_wrap">
        <span class="sui-input-label__star"></span>
        <h4>Datepicker</h4>
      </div>
      <div class="comm_view_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label label="기본형" :required="false" :vertical="false"></sui-input-label>
          </div>
          <div class="col-xs-5">
            <sui-date-picker :disabled="false" sticky></sui-date-picker>
          </div>
          <div class="col-xs-1">
            <sui-input-label label="disabled" :required="false" :vertical="false"></sui-input-label>
          </div>
          <div class="col-xs-5">
            <sui-date-picker disabled></sui-date-picker>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label sticky label="월달력" :required="false" :vertical="false"></sui-input-label>
          </div>
          <div class="col-xs-5">
            <sui-date-picker format="yyyy-MM" initial-view="month" minimum-view="month" sticky></sui-date-picker>
          </div>
          <div class="col-xs-1">
            <sui-input-label label="기간선택" :required="false" :vertical="false"></sui-input-label>
          </div>
          <div class="col-xs-5">
            <sui-date-picker sticky v-model="start_date" placeholder="시작일 입력" :disabled-dates="disabledStartDate"></sui-date-picker>
            <div class="comp_spacing"></div>
            <sui-date-picker sticky v-model="end_date" placeholder="종료일 입력" :disabled-dates="disabledEndDate"></sui-date-picker>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label label="일시" :required="false" :vertical="false"></sui-input-label>
          </div>
          <div class="col-xs-5">
            <div class="comm_label"> 2019-01-20 09:35:15</div>
          </div>
          <div class="col-xs-1">
            <sui-input-label label="readonly" :required="false" :vertical="false"></sui-input-label>
          </div>
          <div class="col-xs-5">
            <sui-date-picker :readonly="true"></sui-date-picker>
          </div>
        </div>
      </div>
    </sui-page-contents>
  </sui-page>
</template>
<script>
  /*global http*/
  export default {
    name: 'TMP_COM_001',
    data() {
      return {
        selectedRangeDate: {
          datePicker: null,
          datePicker1: '2019-08-20',
          nullType: null,
          stringType: '2019-01-01~2019-01-03',
          objectNullType: {
            from: '',
            to: '',
          },
          objectType: {
            from: '2019-05-01',
            to: '',
          },
          // dataset: { from: '2019-11-10', to: '2019-11-15' },
          dataset: { from: '', to: '' },
          datasetString: '',
        },
        myToolTip: 'my tool tip',
        singleCheckbox: false,
        multiCheckbox: [],
        radioStrValue: 'radio1',
        totalPageCount: 8,
        totalDataCount: 80,
        currentPage: 1,
        start_date: '',
        end_date: '',
        defaultGridData: {
          dataSource: {
            localdata: [
              ['Alfreds Futterkiste', 'Berlin', 'Germany'],
              ['Ana Trujillo Emparedados y helados', 'Mxico D.F.', 'Mexico'],
              ['Antonio Moreno Taquera', 'Mxico D.F.', 'Mexico'],
              ['Around the Horn', 'London', 'UK'],
              ['Berglunds snabbkp', 'Lule', 'Sweden'],
              ['Blauer See Delikatessen', 'Mannheim', 'Germany']
            ],
            datafields: [{
              name: 'CompanyName',
              type: 'string',
              map: '0'
            }, {
              name: 'City',
              type: 'string',
              map: '1'
            }, {
              name: 'Country',
              type: 'string',
              map: '2'
            }],
            datatype: 'array'
          },
          columns: [{
            text: 'Company Name',
            datafield: 'CompanyName'
          }, {
            text: 'City',
            datafield: 'City'
          }, {
            text: 'Country',
            datafield: 'Country'
          }]
        }
      };
    },
    watch: {
      totalPageCount(newValue) {
        this.totalDataCount = newValue * 10;
      }
      ,multiCheckbox(newValue){
        console.log(this.multiCheckbox);
      }
    },
    computed: {
      disabledStartDate() {
        return {
          from: new Date(this.end_date),
          to: null
        };
      },
      disabledEndDate() {
        return {
          from: null,
          to: new Date(this.start_date)
        };
      }
    },
    mounted() {}
  };
</script>
<style scoped>
</style>
